import {FormControl, FormHelperText, Grid} from '@material-ui/core';
import {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';
import FieldDetail, {PSIXField} from './FieldDetail';
import Show from 'components/utils/Show';
import pluralize from 'pluralize';

const VesselModalFormFields = ({vessel}) => {
    // abstracted component purely to be in the correct (sub) form context
    const {watch, errors} = useFormContext();
    const {trigger} = useFormContext();
    const vesselType = watch('vessel_type');
    const oiType = watch('offshore_installation_type');
    const nErrors = Object.keys(errors).length;

    useEffect(() => {
        trigger();
    }, [trigger]);

    return (
        <Grid item xs={12}>
            <PSIXField name='vessel_name' vessel={vessel} />
            {['flag', 'uniformed_service_vessel'].map(field => (
                <FieldDetail name={field} value={vessel?.[field]} key={field} />
            ))}
            {[
                'uscg_official_number',
                'imo_number',
                'mmsi',
                'state_registration_number',
                'other_registration_number',
            ].map(field => (
                <FieldDetail
                    name={field}
                    value={vessel?.[field] && parseInt(vessel?.[field])}
                    optional={true}
                    key={field}
                />
            ))}
            <PSIXField name='tonnage' vessel={vessel} />
            <FieldDetail
                name='tonnage_type'
                value={vessel?.tonnage_type}
                hide={vessel?.origin === 'psix'}
            />
            <PSIXField name='length_tonnage' vessel={vessel} />
            <FieldDetail
                name='engine_horsepower'
                value={vessel?.engine_horsepower}
            />
            <FieldDetail
                name='engine_mode_of_propulsion'
                value={vessel?.engine_mode_of_propulsion}
            />
            <FieldDetail name='vessel_type' value={vessel?.vessel_type} />
            <Show
                condition={
                    vesselType === 'Tank Ship' || vesselType === 'Tank Barge'
                }
            >
                <FieldDetail
                    name='tankship_or_barge_type'
                    value={vessel?.tankship_or_barge_type}
                />
            </Show>
            <Show condition={vesselType === 'Offshore Installation'}>
                <FieldDetail
                    name='offshore_installation_type'
                    value={vessel?.offshore_installation_type}
                />
                <Show condition={oiType === 'Mobile Offshore Drilling Unit'}>
                    <FieldDetail
                        name='offshore_installation_MODU_type'
                        value={vessel?.offshore_installation_MODU_type}
                    />
                    <FieldDetail
                        name='offshore_installation_MODU_propulsion_type'
                        value={
                            vessel?.offshore_installation_MODU_propulsion_type
                        }
                    />
                </Show>
                <Show condition={oiType === 'Floating Offshore Installation'}>
                    <FieldDetail
                        name='offshore_installation_FOI_type'
                        value={vessel?.offshore_installation_FOI_type}
                    />
                </Show>
            </Show>
            <Show condition={nErrors !== 0}>
                <FormControl error={true}>
                    <FormHelperText>
                        This form has {nErrors} {pluralize('errors', nErrors)}.
                        If you have trouble entering the data please use 'Edit
                        Advanced Fields'.
                    </FormHelperText>
                </FormControl>
            </Show>
        </Grid>
    );
};

export default VesselModalFormFields;
